import { memo } from "react";

import IconWithTooltip from "components/IconWithTooltip";
import RunPriorityMenuItems from "components/Run/elements/RunPriorityMenuItems";
import ButtonIcon from "ds/components/ButtonIcon";
import DropdownMenu from "ds/components/DropdownMenu";
import { RUN_PRIORITY_PRESETS } from "shared/Run/priorityPresets";
import { RunPriorityPreset } from "types/generated";
import { AccessResult } from "utils/access";

type WorkerPoolQueuedRunsListItemPriorityDropdownProps = {
  priorityPreset: RunPriorityPreset;
  onSetPriority: (preset: RunPriorityPreset) => void;
  canPrioritize: AccessResult;
};

const WorkerPoolQueuedRunsListItemPriorityDropdown = ({
  priorityPreset,
  onSetPriority,
  canPrioritize,
}: WorkerPoolQueuedRunsListItemPriorityDropdownProps) => {
  const { icon, color, label } = RUN_PRIORITY_PRESETS[priorityPreset];

  // A bare `{ result: false }` means the priority is read-only, `{ result: false, message }` means show disabled.
  const isReadOnly = !canPrioritize.result && !canPrioritize.message;

  if (isReadOnly) {
    return (
      <IconWithTooltip icon={icon} color={color} tooltip={label} tooltipWidthMode="maxWidthSm" />
    );
  }

  return (
    <DropdownMenu
      triggerComponent={
        <ButtonIcon icon={icon} iconColor={color} variant="ghost" disabled={!canPrioritize.result}>
          {canPrioritize.message ? `${label}. ${canPrioritize.message}` : label}
        </ButtonIcon>
      }
    >
      <RunPriorityMenuItems
        current={priorityPreset}
        onSelect={onSetPriority}
        canPrioritize={canPrioritize}
      />
    </DropdownMenu>
  );
};

export default memo(WorkerPoolQueuedRunsListItemPriorityDropdown);
